import './styles/CourseTooltip.scss';

import { Divider } from '@mui/material';

import { FunctionComponent } from 'react';

import { Course } from 'types/AppTypes';

interface Props {
  title: string;
  courses: Course[];
}

export const CourseTooltip: FunctionComponent<Props> = props => {
  return (
    <div className="course-tooltip">
      <span className="course-tooltip__title">{props.title}</span>
      <ul>
        {props.courses.map((c, index) => {
          return (
            <li key={c.id}>
              {c.name} {props.courses.length !== index + 1 && <Divider className="divider" />}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
